export default {
  name: 'marking--errorModel',
  apiService: 'shoes',
  apiPath: '/admin/error_model',
};